<div class="dialog-container">
  <mat-card class="no-shadow">
    <mat-card-header class="title">
      <mat-card-title class="no-subtitle">Monthly Totals</mat-card-title>
      <button mat-icon-button color="primary" (click)="onCloseDialog()" tabindex="-1">
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-header>

    <mat-card-content>
      <app-data-box headerTitle="PROJ" class="mt-32">
        <div class="data-box-content text-sm">Total projected credit.</div>
      </app-data-box>

      <app-data-box headerTitle="PPROJ" class="mt-24">
        <div class="data-box-content text-sm">Total projected pay. The greater of scheduled or actual.</div>
      </app-data-box>

      <app-data-box headerTitle="GTD" class="mt-24">
        <div class="data-box-content text-sm">
          Greater Time to Date. A running accumulation of your credited hours to date.
        </div>
      </app-data-box>

      <app-data-box headerTitle="IMAX" class="mt-24">
        <div class="data-box-content text-sm">
          Individual Projection Maximum. The highest pay and credit allowable per your history.
          Includes pay and credit for any activity (flight pay, training, vacation, premium credited
          activity, etc.).

          <div class="compass-link">
            <a href="https://www.alliedpilots.org/LinkClick.aspx?fileticket=U45ee9xQzzs%3d&portalid=0" target="_blank"
              class="link text-sm">
              <mat-icon [inline]="true">launch</mat-icon>
              Compass IMAX Guide
            </a>
          </div>
        </div>
      </app-data-box>
    </mat-card-content>
  </mat-card>
</div>